import { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";

const CountUp = ({ target = 20, duration = 1500, decimals = 0 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          animateCount();
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const animateCount = () => {
    const start = performance.now();
    const factor = Math.pow(10, decimals);

    const update = (currentTime) => {
      const progress = Math.min((currentTime - start) / duration, 1);
      const value = Math.floor(progress * target * factor) / factor;
      setCount(value);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        setCount(target);
      }
    };

    requestAnimationFrame(update);
  };

  const displayValue =
    decimals > 0 ? count.toFixed(decimals) : String(Math.floor(count));

  return (
    <span ref={ref} className={styles.countUp}>
      {displayValue}
    </span>
  );
};

export default CountUp;
